<template>
  <div class="paper-coverage-container">
    <div class="paper-coverage-heading">Chapterwise Coverage</div>
  <div class="paper-coverage">
    <div
      class="paper-coverage-subject"
      v-for="subject in data.subjects"
      :key="subject.id + '' + subject.question_type_id"
    >
      <div class="paper-coverage-subject-title">
        {{ subject.name }} {{ subject.question_type_name }}
      </div>
      <div class="page-coverage-cha">
        <div class="page-coverage-chapters" v-for="chapter in subject.chapters" :key="chapter.id">
          <div class="pc--chapter-title">{{ chapter.name }}: <span class="primary-color">{{ chapter.questions.length }} {{ chapter.questions.length > 1 ? 'Questions': 'Question' }}</span> </div>
          <!-- <div class="pc--number-question">Number of questions:- {{ chapter.questions.length }}</div> -->
          <div class="que-count-scr-block">
            <div class="qu-num-ccen" v-for="(qp, idx) in chapter.questions" :key="idx">
              <button
                    class="que-num-c" :class="getColorName(qp, idx)"
                    @click="data.goToQuestion(qp, idx,subject)"
                >
                   {{ qp.index }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: "PaperCoverage",
  props: ["data", "onClose"],
  mounted() {
  },
  methods: {
    getColorName(pallet, idx) {
      var color = "";
      color = this.getColorForCustomTest(pallet);
      return color + "-paper";
    },
    getColorForCustomTest(pallet) {
      var color = this.QUESTION_STATUS_COLOR.ANSWER_NOT_SELECTED_REVIEW;
      switch (pallet.difficulty) {
        case 1:
          color = this.PAST_QUESTION_COLOR.CORRECT;
          break;
        case 2:
          color = this.QUESTION_STATUS_COLOR.ANSWER_NOT_SELECTED_REVIEW;
          break;
        case 3:
          color = this.PAST_QUESTION_COLOR.INCORRECT;
          break;

        case "default":
          color = this.QUESTION_STATUS_COLOR.ANSWER_NOT_SELECTED_REVIEW;
          break;
      }
      return color;
    },
  },
};
</script>
